import { Navigate, Outlet, useLocation } from 'react-router';

import { useSession } from './use-session';

export function RequireAuth() {
  const { token } = useSession();
  const location = useLocation();
  if (!token) {
    return (
      <Navigate to="/sign-in" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }
  return <Outlet />;
}
